import { render, staticRenderFns } from "./SettingsPlace.vue?vue&type=template&id=5776bace&scoped=true"
import script from "./SettingsPlace.vue?vue&type=script&lang=js"
export * from "./SettingsPlace.vue?vue&type=script&lang=js"
import style0 from "./SettingsPlace.vue?vue&type=style&index=0&id=5776bace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5776bace",
  null
  
)

export default component.exports